import useFetch, { UseFetch, CachePolicies } from 'use-http'
import { addSuperAdminHeaders } from 'utils/superAdmin/superAdminUtils'
import useThriveAuth from './useThriveAuth'
import { getSkipEmailAccessToken } from 'app/Bookings/utils'

// Type any is intentional here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useApi = <TData = any>(
  endpoint?: string,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies?: any[],
  cachePolicy: CachePolicies = CachePolicies.NETWORK_ONLY,
  redirectOnUnauthorized = true
): UseFetch<TData> => {
  const { getAccessTokenSilently, loginWithRedirect } = useThriveAuth()

  const requestConfig = {
    cachePolicy,
    interceptors: {
      request: async ({ options }) => {
        try {
          const token = getAccessTokenSilently() ?? getSkipEmailAccessToken()
          options.headers.Authorization = `Bearer ${token}`

          options = addSuperAdminHeaders(options)
        } catch (error) {
          // Not handling error
        }

        return options
      },
      response: ({ response }) => {
        if (response.status === 401 && redirectOnUnauthorized) {
          loginWithRedirect({ clearCredentials: true })
        }

        return response
      },
    },
  }
  const serverUrl = `${process.env.NEXT_PUBLIC_SERVER_URL}${endpoint || ''}`

  return useFetch<TData>(serverUrl, requestConfig, dependencies)
}

export default useApi
